<template>
  <div>
    <v-data-table class="elevation-1" :headers="headers" :items="items" :loading="loading" :items-per-page="30"
                  :options.sync="params.options" :server-items-length="params.total" disable-sort
                  :footer-props="{showFirstLastPage: true, showCurrentPage: true, itemsPerPageOptions: [30, 50, 100]}">
      <template v-slot:top>
        <v-toolbar flat>
          <v-toolbar-title>关键词</v-toolbar-title>
          <v-responsive class="ml-2 mt-5" max-width="270">
            <asin-selector v-model="params.filters.asin" @input="getData"/>
          </v-responsive>
          <v-spacer></v-spacer>
          <v-simple-checkbox on-icon="mdi-text-recognition" off-icon="mdi-format-text" v-model="params.filters.strictMode"/>
          <v-text-field class="search" append-icon="mdi-magnify" label="搜索"
                        single-line hide-details clearable v-model="params.filters.search" @click:append="getData"
                        @click:clear="clear" @keydown.enter="getData"></v-text-field>
          <v-btn icon @click="openFilterDialog">
            <v-icon>mdi-filter-menu</v-icon>
          </v-btn>
          <v-btn icon @click="openUploadDialog">
            <v-icon>mdi-file-upload</v-icon>
          </v-btn>
          <v-btn icon @click="openCleanDialog">
            <v-icon>mdi-delete</v-icon>
          </v-btn>
          <v-btn icon @click="getData">
            <v-icon>mdi-refresh</v-icon>
          </v-btn>
        </v-toolbar>
        <v-divider/>
      </template>
      <template v-slot:item.imageUrl="{ item }">
        <img alt="商品主图" :src="item.imageUrl" height="80" width="80"/>
      </template>
      <template v-slot:item.asin="{ item }">
        <label>{{ item.asin }}</label>
        <div class="grey--text text-caption">({{ item.marketCode }})</div>
      </template>
      <template v-slot:item.key="{ item }">
        <span>{{ item.key }}</span>
        <v-edit-dialog :return-value.sync="item.remark" @save="update(item)">
          <span v-if="item.remark" class="text-caption grey--text">
            {{ item.remark }}
          </span>
          <v-icon v-else small>mdi-content-paste</v-icon>
          <template v-slot:input>
            <v-text-field single-line counter autofocus label="备注" v-model="item.remark"/>
          </template>
        </v-edit-dialog>
      </template>
      <template v-slot:item.searchVolume="{ item }">
        <div v-html="formatSearchVolume(item)"></div>
      </template>
      <template v-slot:item.type="{ item }">
        <v-responsive width="90" class="mx-auto">
          <v-select dense hide-details :items="types" v-model="item.type" @change="updateKeyword(item)">
            <template v-slot:selection="data">
              <span v-if="data.item.value === -1" class="error--text">{{ data.item.text }}</span>
              <span v-else-if="data.item.value === 1" class="primary--text">{{ data.item.text }}</span>
              <span v-else>{{ data.item.text }}</span>
            </template>
            <template v-slot:item="data">
              <span v-if="data.item.value === -1" class="error--text">{{ data.item.text }}</span>
              <span v-else-if="data.item.value === 1" class="success--text">{{ data.item.text }}</span>
              <span v-else>{{ data.item.text }}</span>
            </template>
          </v-select>
        </v-responsive>
      </template>
      <template v-slot:item.actions="{ item }">
        <v-btn icon @click="openTrendDialog(item)">
          <v-icon>mdi-chart-areaspline-variant</v-icon>
        </v-btn>
      </template>
    </v-data-table>
    <keyword-filter-dialog :visible.sync="filterDialog" :filters="params.filters" @reload="getData"/>
    <keyword-upload-dialog :visible.sync="uploadDialog" @reload="getData"/>
    <keyword-trend-dialog :visible.sync="trendDialog" :item="selectedItem"/>
    <keyword-clean-dialog :visible.sync="cleanDialog" @reload="getData"/>
  </div>
</template>

<script>
import KeywordUploadDialog from "@/page/Keyword/KeywordUploadDialog";
import KeywordTrendDialog from "@/page/Keyword/KeywordTrendDialog";
import KeywordFilterDialog from "@/page/Keyword/KeywordFilterDialog";
import KeywordCleanDialog from "@/page/Keyword/KeywordCleanDialog";
import AsinSelector from "@/components/AsinSelector";

export default {
  name: "KeywordManager",
  components: {AsinSelector, KeywordCleanDialog, KeywordFilterDialog, KeywordTrendDialog, KeywordUploadDialog},
  data() {
    return {
      loading: false,
      filterDialog: false,
      uploadDialog: false,
      trendDialog: false,
      cleanDialog: false,
      headers: [
        {text: "商品主图", align: "center", value: "imageUrl"},
        {text: "ASIN", align: "center", value: "asin"},
        {text: "关键词", align: "center", value: "key", width: 500},
        {text: "排名", align: "center", value: "organicRank"},
        {text: "广告排名", align: "center", value: "sponsoredRank"},
        {text: "查询量(趋势)", align: "center", value: "searchVolume"},
        {text: "记录日期", align: "center", value: "recordDate"},
        {text: "类型", align: "center", value: "type"},
        {text: "操作", align: "center", value: "actions"}
      ],
      params: {
        options: {},
        filters: {
          asin: null,
          key: null,
          type: null,
          minOrganicRank: null,
          maxOrganicRank: null,
          minSponsoredRank: null,
          maxSponsoredRank: null,
          minSearchVolume: null,
          maxSearchVolume: null,
          minSearchVolumeTrend: null,
          maxSearchVolumeTrend: null,
          beginDate: null,
          endDate: null,
          includePass: false,
          strictMode: false,
        },
        total: null
      },
      types: [
        {value: 0, text: "未设置"},
        {value: -1, text: "否定词"},
        {value: 1, text: "肯定词"},
      ],
      asins: [],
      items: [],
      selectedItem: null
    }
  },
  methods: {
    getData() {
      this.loading = true;
      this.items = [];
      this.$axios.post("/keywords", this.params).then(
          response => {
            this.items = response.data.list;
            this.params.total = response.data.total;
            this.loading = false;
          }
      );
    },
    updateKeyword(item) {
      this.loading = true;
      let formData = new FormData();
      formData.append("type", item.type);

      this.$axios.patch(`keyword/${item.asin}/${item.key}`, formData).then(
          () => {
            this.$bus.$emit("msg", "修改成功!");
            this.loading = false;
          }
      );
    },
    clear() {
      this.params.filters.search = null;
    },
    update(item) {
      this.loading = true;
      let formData = new FormData();
      formData.append("remark", item.remark);

      this.$axios.patch(`/keyword/${item.asin}/${item.key}`, formData).then(
          () => {
            this.loading = false;
            this.$bus.$emit("msg", "修改备注成功.");
          }
      );
    },
    openFilterDialog() {
      this.filterDialog = true;
    },
    openUploadDialog() {
      this.uploadDialog = true;
    },
    openTrendDialog(item) {
      this.selectedItem = item;
      this.trendDialog = true;
    },
    openCleanDialog() {
      this.cleanDialog = true;
    },
    getAsinImage(asin) {
      for (let item of this.asins) {
        if (item.asin === asin) {
          return item.imageUrl;
        }
      }
    },
    formatSearchVolume(item) {
      if (item.searchVolumeTrend) {
        if (item.searchVolumeTrend > 0) {
          return `${item.searchVolume ? item.searchVolume : ""} <span class="error--text">(+${item.searchVolumeTrend})</span>`;
        } else {
          return `${item.searchVolume ? item.searchVolume : ""} <span class="success--text">(${item.searchVolumeTrend})</span>`;
        }
      } else {
        return item.searchVolume;
      }
    },
  },
  watch: {
    "params.options": {
      deep: true,
      handler() {
        this.getData();
      }
    }
  },
}
</script>

<style scoped>

</style>